import { PERSONALITY_PROFILES } from "../data/personalityProfiles";
import { PERSONALITY_RELATIONSHIPS } from "../data/personalityRelationships";

/**
 * Calculates similarity between a student's
 * behaviour profile and a personality profile.
 */
function calculateSimilarity(studentProfile, personalityProfile) {
  let total = 0;
  let count = 0;

  Object.entries(personalityProfile).forEach(([dimension, target]) => {

    const student = studentProfile[dimension];

    if (typeof student !== "number") return;

    const difference = Math.abs(student - target);

    total += 100 - difference;

    count++;

  });

  return count ? total / count : 0;
}

/**
 * Ranks all personality profiles according to their
 * similarity with the applicant's behavioural profile.
 */
export function rankPersonalityProfiles(
  studentProfile
) {
  return Object.entries(
    PERSONALITY_PROFILES
  )
    .map(([type, personalityProfile]) => {
      const behaviourProfile =
        personalityProfile?.behaviourProfile;

      if (!behaviourProfile) {
        return null;
      }

      return {
        type,

        similarity:
          calculateSimilarity(
            studentProfile,
            behaviourProfile
          )
      };
    })
    .filter(Boolean)
    .sort(
      (a, b) =>
        b.similarity - a.similarity
    );
}

export function getSecondaryPersonality(
  primaryType,
  studentProfile
) {
  const relationships =
    PERSONALITY_RELATIONSHIPS[primaryType];

  if (!relationships?.length) {
    console.warn(
      `No secondary personality relationships defined for "${primaryType}".`
    );

    return null;
  }

  const ranking =
    rankPersonalityProfiles(
      studentProfile
    );

  const primaryMatch =
    ranking.find(
      candidate =>
        candidate.type === primaryType
    );

  const secondaryMatch =
    ranking.find(candidate =>
      candidate.type !== primaryType &&
      relationships.some(
        relationship =>
          relationship.profile ===
          candidate.type
      )
    );

  if (!secondaryMatch) {
    return null;
  }

  const relationship =
    relationships.find(
      item =>
        item.profile ===
        secondaryMatch.type
    );

  return {
    primary: primaryType,

    primarySimilarity:
      Math.round(
        primaryMatch?.similarity || 0
      ),

    secondary:
      secondaryMatch.type,

    similarity:
      Math.round(
        secondaryMatch.similarity
      ),

    gap:
      Math.round(
        (primaryMatch?.similarity || 0) -
        secondaryMatch.similarity
      ),

    relationship
  };
}